const currency = new Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
});

export const money = (n) => currency.format(n);

// Public assets (images, product photos) resolve against PUBLIC_URL so they work under HashRouter and "homepage": ".".
export const asset = (path) => /^https:\/\//.test(path || "") ? path : path?.startsWith("storage:product-photos/")
  ? `${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/product-photos/${path.slice("storage:product-photos/".length)}`
  : `${process.env.PUBLIC_URL}/${path}`;

export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;
